import { Spinner } from '@/components/Spinner';
import { PointAgentTab } from '@/features/points-management/points-configuration/pointConfiguration.constants';
import { usePointCategoryDetail } from '@/features/points-management/points-configuration/hooks/usePointDetails';
import ManagePointCategory from './ManagePointCategory';

const ManagePointCategoryContainer = ({
  activeTab,
  pointCategoryId,
}: {
  activeTab: PointAgentTab;
  pointCategoryId?: string;
}) => {
  const { category, isLoading } = usePointCategoryDetail(pointCategoryId);

  if (isLoading) return <Spinner />;

  return <ManagePointCategory activeTab={activeTab} category={category} />;
};

export default ManagePointCategoryContainer;
